import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=69ac3406&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=69ac3406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ac3406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VLayout})
